import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CompanySwapperService {
  public companies$: Observable<{ id: string; name: string }[]>;

  constructor(private httpClient: HttpClient) {
    this.companies$ = this.httpClient
      .get<{ companies: { id: string; name: string }[] }>(`${environment.api}/v1/internal_or_external_dispatcher/list_companies`)
      .pipe(
        map((results) => results.companies),
        shareReplay(1),
      );
  }

  public swapCompany(companyId: string) {
    return this.httpClient.post(`${environment.api}/v1/internal/swap_company`, { companyId });
  }
}
